<div class="container">
  <div class="row">
    <div style="width: 100%">
      <div class="card-body">
        @if (linkMyCase) {
        <div>
          <h1 class="static-text">
            {{ "MY_LETTERS_STATIC_TEXT1" | globalTranslate
            }}<a [routerLink]="['/user-profile', 'case-link']"
              ><strong>{{
                "MY_LETTERS_STATIC_TEXT2" | globalTranslate
              }}</strong></a
            >
            {{ "MY_LETTERS_STATIC_TEXT3" | globalTranslate }}
          </h1>
        </div>
        } @if (!linkMyCase) {
        <div>
          <h1 class="static-text">
            {{ "LTSS_LETTERS_STATIC1" | globalTranslate }}
          </h1>
          <div>
            <strong>{{ "NOTE" | globalTranslate }} </strong>
            {{ "MY_LETTERS_STATIC_TEXT5" | globalTranslate }}
          </div>
          <p class="mt-3">{{ "LTSS_LETTERS_STATIC2" | globalTranslate }}</p>
          <form [formGroup]="search">
            <nh-field
              label="{{ 'TYPE_OF_LETTER' | globalTranslate }}"
              [isRow]="true"
              [mandatory]="false"
              [attr.aria-required]="false"
              class="label-section"
            >
              <select
                nhTranslate
                name="type"
                [attr.aria-label]="'TYPE_OF_LETTER' | globalTranslate"
                [items]="items"
                formControlName="type"
                bindLabel="value"
                bindValue="code"
              ></select>
            </nh-field>
            <div class="row g-3">
              <div class="col-md-6">
                <nh-field
                  label="{{ 'BEGIN_DATE' | globalTranslate }}"
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      name="beginDate"
                      class="form-control"
                      formControlName="beginDate"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      (bsValueChange)="verifyTwoDates($event, 'beginDate')"
                      (change)="verifyTwoDates($event, 'beginDate')"
                      bsDatepicker
                      nh
                    />
                  </nh-datepicker>
                  @if (beginDateError?.isError) {
                  <div class="error-messages position-relative">
                    <span class="form-text invalid-tooltip d-block">{{
                      beginDateError.errorMessage | globalTranslate
                    }}</span>
                  </div>
                  }
                </nh-field>
              </div>
              <div class="col-md-6">
                <nh-field
                  label="{{ 'END_DATE' | globalTranslate }}"
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      name="endDate"
                      class="form-control"
                      formControlName="endDate"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      (bsValueChange)="verifyTwoDates($event, 'endDate')"
                      (change)="verifyTwoDates($event, 'endDate')"
                      bsDatepicker
                      nh
                    />
                  </nh-datepicker>
                  @if (endDateError?.isError) {
                  <div class="error-messages position-relative">
                    <span class="form-text invalid-tooltip d-block">{{
                      endDateError.errorMessage | globalTranslate
                    }}</span>
                  </div>
                  }
                </nh-field>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <button
                  id="continue"
                  [disabled]="
                    beginDateError?.isError ||
                    endDateError?.isError ||
                    !this.search.controls.beginDate.value ||
                    !this.search.controls.endDate.value ||
                    this.search.controls.beginDate.invalid ||
                    this.search.controls.endDate.invalid
                  "
                  class="btn btn-secondary btn-search"
                  (click)="searchData()"
                >
                  {{ "SEARCH" | globalTranslate }}
                  <i class="fa fa-search ms-2"></i>
                </button>
              </div>
            </div>
          </form>
          @if (rows?.length) {
          <div class="mt-3">
            <div class="d-none d-lg-block">
              <h1 class="label-section">
                <strong
                  >{{ "DISPLAYING" | globalTranslate }} {{ start }}-{{ end }}
                  {{ "OF" | globalTranslate }} {{ rows.length }}
                  {{ "NOTICE" | globalTranslate }}</strong
                >
              </h1>
              <ngx-datatable
                class="bootstrap material"
                #table
                [rows]="rows"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowClass]="getRows"
                [rowHeight]="'auto'"
                [limit]="5"
                (page)="landed($event)"
                [messages]="{ emptyMessage: this.emptyMessage }"
              >
                <ngx-datatable-column
                  name="{{ 'Letter Name' | globalTranslate }}"
                  [width]="250"
                >
                  <ng-template
                    ngx-datatable-cell-template
                    let-row="row"
                    let-rowIndex="rowIndex"
                  >
                    <div class="letter-name-wrapper">
                      @if (row.viewed == 'Yes') {
                      <img
                        src="../../assets/images/Icons/Open_Letter.svg"
                        alt="close-icon"
                        height="20px"
                      />
                      } @if (row.viewed == 'No') {
                      <img
                        src="../../assets/images/Icons/Close_Letter.svg"
                        alt="close-icon"
                        height="20px"
                      />
                      }
                      <div class="letter-name">
                        {{ row.letterName }}
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  name="{{ 'Letter For' | globalTranslate }}"
                  [width]="145"
                >
                  <ng-template
                    ngx-datatable-cell-template
                    let-row="row"
                    let-rowIndex="rowIndex"
                  >
                    <div>
                      {{ row.letterFor }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  name="{{ 'DATE' | globalTranslate }}"
                  [width]="128"
                >
                  <ng-template
                    ngx-datatable-cell-template
                    let-row="row"
                    let-rowIndex="rowIndex"
                  >
                    <div>
                      {{ row.date }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  name="{{ 'Letter Viewed?' | globalTranslate }}"
                  [width]="120"
                  headerClass="text-center"
                >
                  <ng-template
                    ngx-datatable-cell-template
                    let-row="row"
                    let-rowIndex="rowIndex"
                  >
                    <div class="text-center">
                      {{ row.viewed }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column [name]="col.name" [prop]="col.prop" *ngFor="let col of columns">
                      </ngx-datatable-column>-->
                <ngx-datatable-column
                  name="{{ 'View' | globalTranslate }}"
                  [width]="120"
                  headerClass="text-center"
                >
                  <ng-template
                    ngx-datatable-cell-template
                    let-row="row"
                    let-rowIndex="rowIndex"
                  >
                    <div class="p-0 hover-red text-center">
                      <a
                        tabindex="0"
                        class="p-0 text-start hover-red btn btn-link"
                        (click)="PrintDoc(row)"
                        ><i class="fa fa-search fa-lg"></i
                      ></a>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
            <div class="nh-table-mobile mt-3 pt-2 d-lg-none">
              @for (row of rows; track row; let i = $index) {
              <div
                class="table-row mb-3 pb-3"
                [ngClass]="{ 'row-highlight': getRows(row) == 'row-highlight' }"
              >
                <div>
                  <div class="mobile-table-header">
                    {{ "Letter Name" | globalTranslate }}
                  </div>
                  <hr />
                  <div class="letter-name-wrapper">
                    @if (row.viewed == 'Yes') {
                    <img
                      src="../../assets/images/Icons/Open_Letter.svg"
                      alt="close-icon"
                      height="20px"
                    />
                    } @if (row.viewed == 'No') {
                    <img
                      src="../../assets/images/Icons/Close_Letter.svg"
                      alt="close-icon"
                      height="20px"
                    />
                    }
                    <div class="letter-name">
                      {{ row.letterName }}
                    </div>
                  </div>
                  <br />
                </div>
                @for (head of columns; track head) {
                <div>
                  <div
                    class="mobile-table-header"
                    [innerHtml]="head.name | globalTranslate | sanitize"
                  ></div>
                  <hr />
                  <div
                    class="mobile-table-data"
                    [innerHTML]="row[head.prop] | sanitize"
                  ></div>
                  <br />
                </div>
                }
                <button
                  class="btn btn-sm btn-secondary w-100"
                  (click)="PrintDoc(row)"
                >
                  <span class="pe-2">{{ "View" | globalTranslate }}</span>
                </button>
              </div>
              } @if (!rows.length) {
              <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
              }
            </div>
          </div>
          } @if (rows?.length === 0) {
          <div>
            <br />
            <p class="mt-3">{{ this.emptyMessage | globalTranslate }}</p>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>